import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { ResponseStatus } from 'const';
import { updateModalWindowOptions } from 'containers/ModalManager/actions';
import * as Models from 'models';
import { updateReusableLayoutTags as updateReusableLayoutTagsAPI } from 'services/api';
import { handleSagaError } from 'services/handleError';
import { Notifications } from 'services/Notifications';
import { intlGet } from 'utils/intlGet';
import * as Action from '../models';

export function* updateReusableLayoutTags(action: Action.Action.UpdateReusableLayoutTags): SagaIterator {
  const { modalWindowId, documentId, tags } = action.payload || {};
  const errorContext = 'LayoutDetailsWindow.updateReusableLayoutTags';
  const errorTitle = 'Update Reusable Layout Tags';

  // Only send the name field; tag fields (audienceType, channelType, contentType)
  // are no longer sent to avoid writing them to Veeva Vault
  const payload = { name: tags.name } as Models.ProjectMetadataTags;

  try {
    yield put(updateModalWindowOptions(modalWindowId, { isSaving: true }));

    const response: Models.Response<Models.ProjectMetadataTags> = yield call(
      updateReusableLayoutTagsAPI,
      documentId,
      payload,
    );

    if (response.responseStatus !== ResponseStatus.SUCCESS || !response.data) {
      yield call(handleSagaError, response?.error, errorContext, errorTitle);

      return;
    }

    yield call([Notifications, Notifications.success], intlGet('Notification.Success', 'UpdateReusableLayoutTags'));
    yield put(updateModalWindowOptions(modalWindowId, { metadata: response.data }));
  } catch (error) {
    yield call(handleSagaError, error, errorContext, errorTitle);
  } finally {
    yield put(updateModalWindowOptions(modalWindowId, { isSaving: false }));
  }
}
